// 处理订单相关的工具类
const dayjs = require("dayjs");
const mathjs = require('mathjs');
//计算时间差值
const CalculateDuration = (startTime, endTime) => {
    const startTimeUnix = dayjs(startTime);
    const endTimeUnix = dayjs(endTime);
    // 计算两个时间之间的差值并将其转换为小时
    const timeDifferenceInMilliseconds = endTimeUnix.diff(startTimeUnix);
    // 将毫秒差值转换为小时
    const hoursDifference = timeDifferenceInMilliseconds / (1000 * 60 * 60);
    return hoursDifference
}

//订单必填校验
/**
 * @param list {Array} 外部传入字段列表
 * @param result {Object} 校验结果 {pass: '',resultList: [],noPassList: [],messsage:''}
 * {
 *  pass {Boolean} 是否校验通过
 *  resultList {Array} 原数组 包含每个样本组未填写的必填项 noPassList
 *  noPassList {Array} 所有样本组未填写的必填项数据
 * 	messsage {String} 返回的信息
 * }
 * 
 */
const requiredVerification = (list) => {
    let verifList = []
    if (list) {
        verifList = JSON.parse(JSON.stringify(list))
    }
    // specimenNum
    let flag = true
    verifList.map(item => {
            if (!item.specimenNum) {
                flag = false
            }
            if (!item.specimenCode) {
                flag = false
            }
        })
        //提取出所有样本的字段列表
    let fieldList = verifList.map(item => item.fieIdList);
    //取出未隐藏且为必填的字段
    let resultList = fieldList.map(item =>
        item.filter(items => !items.hide && items.isRequired === 1)
    );
    let allNoPassList = []
        //定义字段映射表
    const fieIdTypeMapping = {
        1: 'valueId',
        2: 'valueId',
        3: 'fieIdValue',
        4: 'fieIdValue',
        5: 'fieIdValue',
        6: 'fieIdValue',
        7: 'fieIdValue',
        8: 'fieIdValue',
        9: 'fieldValueRange',
        10: 'fieIdValue'
    };
    let noPassNum = 0

    resultList.forEach(item => {
        item.forEach(items => {
            items.noPassList = [];
            const prop = fieIdTypeMapping[items.fieIdType];
            if (prop) {
                // 为空则是未填写
                if (items[prop] == '' || items[prop] == null || items[prop] === undefined) {
                    noPassNum++;
                    items.noPassList.push(items);
                    allNoPassList.push(items)
                }
            }
        });
    });
    let result = {
        pass: true,
        noPassList: [],
        // resultList: [],
        resultList,
        messsage: ''
    }
    if (flag) {
        // if(resultList[0])
        if (noPassNum > 0) {
            result.pass = false
            result.noPassList = allNoPassList
            result.messsage = '请填写' + allNoPassList[0].fieIdName + '字段'
        }
    } else {
        result.pass = false,
            result.messsage = '请填写样品数量或者样品编号'
    }
    return result
}

//更新时间
const timeValue = (Selected, data) => {
    const itemToUpdate = data.fieIdList.find(item => item.fieIdId === Selected.fieIdId);
    if (Selected.isEnableCalendar == 1) {
        itemToUpdate.appointmentStartDate = Selected.appointmentStartDate
        itemToUpdate.appointmentEndDate = Selected.appointmentEndDate
    } else {
        itemToUpdate.duration = Selected.duration
        itemToUpdate.fieIdValue = Selected.duration
    }
    //如果是日历预约则计算出时长
    if (Selected.isEnableCalendar == 1) {
        if (itemToUpdate.appointmentStartDate && itemToUpdate.appointmentEndDate) {
            itemToUpdate.value = CalculateDuration(itemToUpdate.appointmentStartDate, itemToUpdate.appointmentEndDate)
            itemToUpdate.fieIdValue = CalculateDuration(itemToUpdate.appointmentStartDate, itemToUpdate.appointmentEndDate)
        } else {
            itemToUpdate.value = 0
            itemToUpdate.fieIdValue = 0
        }
    } else {
        if (itemToUpdate.duration) {
            itemToUpdate.value = itemToUpdate.duration
            itemToUpdate.fieIdValue = itemToUpdate.duration
        } else {
            itemToUpdate.value = 0
            itemToUpdate.fieIdValue = 0
        }
    }

    return data
}

const showFieId = (selected ,list) => {
    const new_list = JSON.parse(JSON.stringify(list))
    const result = []
    new_list.fieIdList.forEach((item, index) => {
        if(item.relevanceField == selected.fieIdId && item.isRelevance) {
            const option_list = item.relevanceOptionId ? item.relevanceOptionId.split(',') : []
            const value_list = selected.valueId ? selected.valueId.toString().split(',') : []
            result.push({
                index: index,
                hide: !option_list.some(i => value_list.includes(i)),
            })
        }
    })
    return result
}

const FieldScreen = (selected, data) => {
    let new_data = JSON.parse(JSON.stringify(data))
    const new_selected = JSON.parse(JSON.stringify(selected))
    // 映射用户选取的值
    const target_index = new_data.fieIdList.findIndex(item => item.fieIdId == new_selected.fieIdId)
    new_data.fieIdList[target_index].options = new_selected.options
    new_data.fieIdList[target_index].fieIdValue = new_selected.fieIdValue
    new_data.fieIdList[target_index].optionId = new_selected.optionId
    new_data.fieIdList[target_index].valueId = new_selected.valueId
    if(new_selected.fieIdType == 9) new_data.fieIdList[target_index].fieldValueRange = new_selected.fieldValueRange
    if(new_selected.fieIdType == 14) new_data.fieIdList[target_index].duration = new_selected.duration

    //处理链式变更的字段
    const queue = showFieId(new_selected, new_data)
    queue.forEach(item => {
        new_data.fieIdList[item.index].hide = item.hide
    })
    const hide_list = queue.filter(item => item.hide)
    hide_list.forEach(i => {
        new_data.fieIdList[i.index].fieIdValue = undefined
        new_data.fieIdList[i.index].optionId = undefined
        new_data.fieIdList[i.index].valueId = undefined
        if(new_selected.fieIdType == 9) new_data.fieIdList[target_index].fieldValueRange = undefined
        if(new_selected.fieIdType == 14) new_data.fieIdList[target_index].duration = undefined
    })
    hide_list.forEach(i => {
        new_data = FieldScreen(new_data.fieIdList[i.index], new_data)
    })
    return new_data
}

//设备预约字段处理
/**
 * @param list {Array} 外部传入的字段类表
 * @param fieIdId {Number} 字段id
 * @param fieIdName {String} 字段名称
 * @param fieIdType {Number} 字段类型 1 单选 2多选 3 单行文本 4 多行文本 5 富文本(小程序处理为多行输入框)  6 整数 7 浮点 8 上传附件 9 数字范围 10 
 * @param isRequired {Number} 是否必填 1是0否
 * @param noCheck {String} 不可检测元素
 * @param elementPrice {Number} 元素价格（单个）
 * @param isRelevance {Number} 字段是否关联 1是0否
 * @param relevanceField {Number} 关联字段id
 * @param relevanceOptionId {Number} 关联选项id
 * @param fileList {Arrar{Object}} 文件list {name: '',url:''}
 */

const FieldProcessing = (list) => {
    //有关联id的初始化需要被隐藏
    list.map(item => {
        if (item.isRelevance) {
            item.hide = true
        } else {
            item.hide = false
        }
    })
    return list
}

//输入框赋值
const inputFieIdValue = (Selected, data) => {
    data.fieIdList.forEach(item => {
        if(item.fieIdId == Selected.fieIdId) {
            item.fieIdValue = Selected.fieIdValue
        }
    })
    return data
}

//范围赋值
const rangeFieIdValue = (Selected, data) => {
    const itemToUpdate = data.fieIdList.find(item => item.fieIdId === Selected.fieIdId);
    let list = []
    if (Selected.type == 1) {
        itemToUpdate.startNum = Number(Selected.fieIdValue)
    }
    if (Selected.type == 2) {
        itemToUpdate.endNum = Number(Selected.fieldValueRange)
    }
    if (itemToUpdate.startNum !== undefined && itemToUpdate.startNum !== null) {
        // list.push(itemToUpdate.startNum)
        itemToUpdate.fieIdValue = itemToUpdate.startNum
    }
    if (itemToUpdate.endNum !== undefined && itemToUpdate.endNum !== null) {
        // list.push(itemToUpdate.endNum)
        itemToUpdate.fieldValueRange = itemToUpdate.endNum
    }
    // itemToUpdate.fieldValueRange = list.join(',')
    return data
}

//更新全局问题字段组数值
const globalGroupFieIdValue = (Selected, data) => {
    const itemToUpdate = data.fieIdList.find(item => item.fieIdId === Selected.fieIdId);
    itemToUpdate.totalPrice = Selected.totalPrice * itemToUpdate.elementPrice
    itemToUpdate.fieldGroupValues = Selected.fieldGroupValues
    if (Selected.bargainReminderList && Selected.bargainReminderList.length > 0) {
        itemToUpdate.bargainReminder = Selected.bargainReminderList[Selected.bargainReminderList.length - 1]
        itemToUpdate.isNegotiatedPrice = 1
    } else {
        itemToUpdate.bargainReminder = null
        itemToUpdate.isNegotiatedPrice = 0
    }
    return data
}

//总金额计算
const getTotalMoneys = (list, value) => {
    return list.reduce((total, item) => {
        if (!isNaN(Number(item[value]))) {
            return total + item[value];
        } else {
            return total;
        }
    }, 0);
}

//合并数组内相同字段id的选项
const mergeNamesById = (arr) => {
    return arr.reduce((acc, current) => {
      const { fieIdId, buffValue , buffUnitPrice , fieIdType , ...rest } = current;
      if (!acc[fieIdId]) {
        acc[fieIdId] = { fieIdId, buffValue: '' , ...rest };
      }
      acc[fieIdId].buffValue = acc[fieIdId].buffValue ? `${acc[fieIdId].buffValue}, ${buffValue}` : buffValue;
      if(fieIdType === 1 || fieIdType === 2){
          acc[fieIdId].buffUnitPrice = acc[fieIdId].buffUnitPrice ? acc[fieIdId].buffUnitPrice : 0
          acc[fieIdId].buffUnitPrice += buffUnitPrice;
      }else{
          acc[fieIdId].buffUnitPrice = buffUnitPrice;
      }
      acc[fieIdId].fieIdType = fieIdType
      return acc;
    }, {});
  }

//转化费用明细
/**
 * 由于需求变更，之前一版的明细已经不可用，时间不够就不改订单计算的方法，直接根据之前的明细列表进行转化，以符合需求
 * @param list {Array} 之前的明细
 * 字段类型 1 单选 2多选 3 单行文本 4 多行文本 5 富文本  6 整数 7 浮点 8 上传附件 9 数字范围 10 元素周期 11附件下载 12字段组 13基本参数 14 预约时长（0.5小时一个单位）
 * 价格计算方式 1 按样品数量：本组样品数量*单价（协议价）3 固定价格：1*单价（协议价）4 不计算价格：不计算价格 
 * @return {list} 转化后的明细列表
 */
const convertBuffList = (list) =>{
	let isNegotiatedPrice = 0
	list.map(item => {
        if(item.sampleName !== '实验需求' && item.sampleName != '订单折扣' && item.sampleName != '优惠费用'){
            if(item.subChargeVOList){
                item.subChargeVOList.map(items => {
                    //按照字段类型 取不同的值 单行文本 、多行文本、富文本、上传附件、附件下载 基本参数不需要判断
                    if(items.fieIdType === 6 || items.fieIdType === 7 || items.fieIdType === 14 || items.fieIdType === 10){
                        items.buffName = items.showFieldName ? items.showFieldName : items.fieIdName
                        items.buffValue = items.fieIdValue
                        items.buffUnitPrice = items.elementPrice
                    }
                    if(items.fieIdType === 12){
                        items.buffName = items.showFieldName ? items.showFieldName : items.fieIdName
                        items.buffValue = ''
                        items.buffUnitPrice = items.totalPrice
                    }
                    if(items.fieIdType === 9){
                        items.buffName = items.showFieldName ? items.showFieldName : items.fieIdName
                        items.buffValue = undefined
                        items.buffUnitPrice = items.elementPrice
                        if ((items.fieldValueRange === 0 || items.fieldValueRange) &&(items.fieIdValue === 0 || items.fieIdValue)) {
                            items.buffValue = items.fieIdValue + "~" + items.fieldValueRange
                        }
                    }
                    if(items.fieIdType === 1 || items.fieIdType === 2){
                        let target = item.fieIdList.filter(item => item.fieIdId === items.fieIdId)[0].options
                        let result = target.filter(item => item.optionId === items.optionId)[0]
                        if(result.isNegotiatedPrice === 1){
                            isNegotiatedPrice = 1
                        }
                        items.buffName = items.showFieldName ? items.showFieldName : items.fieIdName
                        items.buffValue = result.optionName
                        items.buffUnitPrice = result.unitPrice
                    }
                })
                //合并多选的选项
                item.subChargeVOList = Object.values(mergeNamesById(item.subChargeVOList));
                item.subChargeVOList = item.subChargeVOList.sort((a, b) => {
                    if (a.originalIndex && b.originalIndex) {
                        if (a.originalIndex.kIndex === b.originalIndex.kIndex) {
                            return a.originalIndex.iIndex - b.originalIndex.iIndex;
                        } else {
                            return a.originalIndex.kIndex - b.originalIndex.kIndex;
                        }
                    }
                })
                //拼接小计公式
                let sumText = ''
                item.subChargeVOList.map(itemx => {
                    if(item.sampleName === '全局问题'){
                            if(itemx.buffUnitPrice !== undefined){
                                if(itemx.fieIdType === 1 || itemx.fieIdType === 2){
                                    if(itemx.buffUnitPrice > 0){
                                        sumText = sumText + '+' + itemx.buffUnitPrice
                                    }
                                }
                                if(itemx.fieIdType === 6 || itemx.fieIdType === 7 || itemx.fieIdType === 14){
                                    if(itemx.buffValue){
                                        if(itemx.buffUnitPrice > 0){
                                            sumText = sumText + '+' + itemx.buffValue + '*' + itemx.buffUnitPrice
                                        }
                                    }
                                }
                                if(itemx.fieIdType === 9) {
                                    if ((itemx.fieldValueRange === 0 || itemx.fieldValueRange) &&(itemx.fieIdValue === 0 || itemx.fieIdValue)) {
                                        let value = Number(itemx.fieldValueRange) - Number(itemx.fieIdValue)
                                        if (value > 0) {
                                            if(itemx.buffUnitPrice > 0){
                                                sumText = sumText + '+' + value + '*' + itemx.buffUnitPrice
                                            }
                                        } 
                                    }
                                }
                                if(itemx.fieIdType === 12) {
                                    if(itemx.buffUnitPrice > 0){
                                        sumText = sumText + '+' + Number(itemx.buffUnitPrice).toFixed(2)
                                    }
                                }
                            }
                    }else{
                        if(itemx.buffUnitPrice !== undefined){
                            if(itemx.fieIdType === 10){
                                if(item.specimenNum){
                                    if(itemx.buffValue){
                                        //获取选中的元素个数
                                        let elementNum = itemx.buffValue.split(',').length
                                        // if(itemx.)
                                        if(itemx.startPrice > 0){
                                            if(elementNum * Number(itemx.buffUnitPrice) <= itemx.startPrice){
                                                sumText = sumText  + '+'+ item.specimenNum + '*' + itemx.startPrice
                                            }else{
                                                sumText = sumText  + '+' + item.specimenNum+ '*' + elementNum + '*' + itemx.buffUnitPrice
                                            }
                                        }else{
                                            sumText = sumText  + '+'+ item.specimenNum + '*' + elementNum + '*' + itemx.buffUnitPrice
                                        }
                                        
                                    }
                                }
                            }
                            
                            if(itemx.calculateWay === 1){
                                if(item.specimenNum){
                                    if(itemx.fieIdType === 1 || itemx.fieIdType === 2){
                                        if(item.specimenNum > 0 && itemx.buffUnitPrice > 0){
                                            sumText = sumText + '+' + item.specimenNum + '*' + itemx.buffUnitPrice
                                        }
                                    }
                                    if(itemx.fieIdType === 6 || itemx.fieIdType === 7 || itemx.fieIdType === 14){
                                        if(itemx.buffValue){
                                            if(item.specimenNum > 0 && itemx.buffUnitPrice > 0){
                                                sumText = sumText + '+'+ item.specimenNum + '*' + itemx.buffValue + '*' + itemx.buffUnitPrice
                                            }
                                        }
                                    }
                                    if(itemx.fieIdType === 9) {
                                        if ((itemx.fieldValueRange === 0 || itemx.fieldValueRange) &&(itemx.fieIdValue === 0 || itemx.fieIdValue)) {
                                            let value = Number(itemx.fieldValueRange) - Number(itemx.fieIdValue)
                                            if (value > 0) {
                                                if(item.specimenNum > 0 && itemx.buffUnitPrice > 0){
                                                    sumText = sumText + '+'+ item.specimenNum + '*' + value + '*' + itemx.buffUnitPrice
                                                }
                                            } 
                                        }
                                    }
                                    if(itemx.fieIdType === 12) {
                                        if(itemx.buffUnitPrice > 0){
                                            sumText = sumText + '+' + Number(itemx.buffUnitPrice).toFixed(2)   
                                        }
                                    }
                                }else{
                                    sumText = sumText + '+0'
                                }
                            }else{
                                if(itemx.fieIdType === 1 || itemx.fieIdType === 2){
                                    if(itemx.buffUnitPrice > 0){
                                        sumText = sumText + '+' + itemx.buffUnitPrice
                                    }
                                }
                                if(itemx.fieIdType === 6 || itemx.fieIdType === 7 || itemx.fieIdType === 14){
                                    if(itemx.buffValue){
                                        if(itemx.buffUnitPrice > 0 && itemx.buffValue > 0){
                                            sumText = sumText + '+' + itemx.buffValue + '*' + itemx.buffUnitPrice
                                        }
                                    }
                                }
                                if(itemx.fieIdType === 9) {
                                    if ((itemx.fieldValueRange === 0 || itemx.fieldValueRange) &&(itemx.fieIdValue === 0 || itemx.fieIdValue)) {
                                        let value = Number(itemx.fieldValueRange) - Number(itemx.fieIdValue)
                                        if (value > 0) {
                                            if(itemx.buffUnitPrice > 0){
                                                sumText = sumText + '+' + value + '*' + itemx.buffUnitPrice
                                            }
                                            
                                        } 
                                    }
                                }
                                if(itemx.fieIdType === 12) {
                                    if(itemx.buffUnitPrice > 0){
                                        sumText = sumText + '+' + Number(itemx.buffUnitPrice).toFixed(2)
                                    }
                                }
                            }
                        }
                    }
                    
                })
                sumText = sumText.replace('+', '');
                item.sumText = sumText
                const math = require('mathjs')
				let result = math.evaluate(sumText);
				if(result === NaN || result === Infinity || result === undefined){
					result = 0
				}
                item.totalPrice = result
            } 
        }
		
	})
    list.map(i =>
        {
            i.subChargeVOList.sort((a, b) => {
                if (a.originalIndex && b.originalIndex) {
                    if (a.originalIndex.kIndex === b.originalIndex.kIndex) {
                        return a.originalIndex.iIndex - b.originalIndex.iIndex;
                    } else {
                        return a.originalIndex.kIndex - b.originalIndex.kIndex;
                    }
                }
            })
        }
    );
	return list
}
//计算总金额
/**
 * @param list {Array} 外部传入的列表
 * @param isGlobal {Boolean} 是否是全局问题
 * @return {object} 返回明细列表和总金额
 */
const getTotalMoneyList = (list, isGlobal) => {
    //如果不是计算全局问题，就要将样品数量存到字段里面
    if (!isGlobal) {
        list.map(item => {
            // specimenNum
            item.values.map(items => {
                items.specimenNum = item.specimenNum
            })
        })
    }else{
        let obj = {
            sampleName: '全局问题',
            values: list
        }
        list = []
        list.push(obj)
    }
    //拿到需要计算价格的数据 字段隐藏状态为false 且 fieIdType为1，2,6,7,9,10,13,14的 其中fieIdType为6，7，9，14的需要isCalculatePrice为1时才需要进行计算
    let fieIdList = list.map(item =>
        item.values.filter(items =>
            !items.hide && [1, 2, 6, 7, 9, 10, 12, 13, 14].includes(items.fieIdType) &&
            (items.fieIdType !== 6 && items.fieIdType !== 7 && items.fieIdType !== 9 && items.fieIdType !== 14 || items.isCalculatePrice === 1) && items.calculateWay != 4
        )
    );
    let totalList = []
        //处理金额相关的字段
    fieIdList.map(k => {
        let list = []
        k.map(i => {
            //元素周期表、整数、浮点数、范围、字段组情况、预约时长
            if (i.fieIdType == 10 || i.fieIdType == 6 || i.fieIdType == 7 || i.fieIdType == 9 || i.fieIdType == 12 || i.fieIdType == 14) {
                //如果 fieIdType类型为 整数、浮点、范围则计算总金额
                if (i.fieIdType == 6 || i.fieIdType == 7 || i.fieIdType == 14) {
                    if (i.fieIdValue) {
                        i.totalPrice = Number(i.fieIdValue) * Number(i.elementPrice)
                    } else {
                        i.totalPrice = 0
                    }
                }
                //范围需要先计算他的差值
                if (i.fieIdType == 9) {
                    if (i.fieldValueRange && i.fieldValueRange) {
                        let value = Number(i.fieldValueRange) - Number(i.fieIdValue)
                        if (value <= 0) {
                            i.totalPrice = 0
                        } else {
                            i.totalPrice = value * Number(i.elementPrice)
                        }
                    } else {
                        i.totalPrice = 0
                    }

                }
                list.push({
                    ...i
                });
            }
            // 单选、多选情况/根据optionId选择的选项id找到对应选项
            if (i.optionId && Array.isArray(i.options)) {
                i.options.forEach(option => {
                    i.optionId.forEach(openid => {
                        if(option.optionId === openid){
                            if(option.unitPrice != 0 || option.isNegotiatedPrice == 1){
                                list.push({
                                    ...option,
                                    fieIdName: i.fieIdName,
                                    specimenNum: i.specimenNum,
                                    calculateWay: i.calculateWay,
                                    fieIdType: i.fieIdType,
                                    //议价字段在选项里面
                                    bargainReminder: option.bargainReminder,
                                    isNegotiatedPrice: option.isNegotiatedPrice
                                });
                            }
                            
                        }
                    })
                });
            }

        })
        totalList.push(list)
    });

    let bargainReminderList = []
    totalList.map(key => {
            key.maps = {}
            key.dest = []
            key.map(item => {
                    //单选、多选金额
                    if (item.fieIdType == 1 || item.fieIdType == 2) {
                        // 根据价格计算方式处理字段(calculateWay)价格
                        // 1 按样品数量 3 固定价格 4 不计算价格
                        if (item.calculateWay == 1) {
                            item.totalPrice = Number(item.unitPrice) * Number(item.specimenNum);
                        } else {
                            item.totalPrice = item.unitPrice
                        }
                        //议价
                        if (item.isNegotiatedPrice == 1) {
                            bargainReminderList.push(item.bargainReminder)
                        }
                    }
                    // 字段组 字段组都直接拿他的totalPrice 字段组可能存在议价的情况
                    if (item.fieIdType == 12) {
                        // 根据价格计算方式处理字段(calculateWay)价格
                        // 1 按样品数量 3 固定价格 4 不计算价格
                        if (item.calculateWay == 1) {
                            if (item.totalPrice) {
                                item.totalPrice = item.totalPrice * item.specimenNum
                            } else {
                                item.totalPrice = 0
                            }
                            if (item.isNegotiatedPrice == 1) {
                                bargainReminderList.push(item.bargainReminder)
                            }
                        } else {
                            if (item.totalPrice) {
                                item.totalPrice = item.totalPrice
                            } else {
                                item.totalPrice = 0
                            }
                            if (item.isNegotiatedPrice == 1) {
                                bargainReminderList.push(item.bargainReminder)
                            }
                        }
                    }
                    //整数、浮点、范围、字段组都直接拿他的totalPrice 字段组可能存在议价的情况
                    if (item.fieIdType == 6 || item.fieIdType == 7 || item.fieIdType == 9 || item.fieIdType == 14) {
                        if (item.totalPrice) {
                            item.totalPrice = item.totalPrice
                            item.totalPrice = mathjs.round(item.totalPrice, 2)
                        } else {
                            item.totalPrice = 0
                        }
                        // if(item.fieIdType == 12){
                        // 	if(item.isNegotiatedPrice == 1){
                        // 		bargainReminderList.push(item.bargainReminder)
                        // 	}
                        // }
                    }
                    //元素周期表
                    //整数、浮点、范围、字段组都直接拿他的fieIdValue
                    if (item.fieIdType == 10) {
                        if (item.fieIdValue) {

                            let elementList = item.fieIdValue.split(',')
                            if (isGlobal) {
                                item.totalPrice = Number(item.elementPrice) * Number(elementList.length)
                            } else {
                                item.totalPrice = Number(item.elementPrice) * Number(elementList.length) * Number(item.specimenNum)
                            }
                            let startPrice = Number(item.elementPrice) * Number(elementList.length)
                            if (startPrice >= item.startPrice) {
                                item.unitPrice = item.totalPrice
                            } else {
                                item.unitPrice = item.startPrice * Number(item.specimenNum)
                                item.totalPrice = item.unitPrice
                            }
                            // item.unitPrice = item.totalPrice
                        }
                    }
                    //字段多选时合并金额
                    if (!key.maps[item.fieIdId]) {
                        key.dest.push(item);
                        key.maps[item.fieIdId] = item;
                    } else {
                        key.dest.map(j =>  {
                            if (item.fieIdId == j.fieIdId) {
                                j.unitPrice = Number(j.unitPrice) + Number(item.unitPrice);
                                j.totalPrice = Number(j.totalPrice) + Number(item.totalPrice);
                            }
                        });
                    }
                })
                //计算单个样品的总金额
            key.totalMomey = getTotalMoneys(key.dest, 'totalPrice')
            key.totalMomey = mathjs.round(key.totalMomey, 2)
            return {
                ...key,
                subChargeVOList: key.dest
            };
        })
        //计算所有样品的总金额
    let totalCost = getTotalMoneys(totalList, 'totalMomey')
    totalCost = mathjs.round(totalCost, 2)
        // totalCost = mathjs.round(mathjs.bignumber(totalCost), 2)
    let result = {
        totalCost,
        totalList,
        bargainReminderList: bargainReminderList,
    }
    return result
}

//计算总金额
/**
 * @param list {Array} 外部传入的列表
 * @param isGlobal {Boolean} 是否是全局问题
 * @return {object} 返回明细列表和总金额
 */
const getTotalMoney = (list_, isGlobal) => {
    //如果不是计算全局问题，就要将样品数量存到字段里面
    const list = JSON.parse(JSON.stringify(list_))
    if (!isGlobal) {
        list.map(item => {
            // specimenNum
            item.fieIdList.map(items => {
                items.specimenNum = item.specimenNum
            })
        })
    }
    //拿到需要计算价格的数据 字段隐藏状态为false 且 fieIdType为1，2,6,7,9,10,13,14的 其中fieIdType为6，7，9，14的需要isCalculatePrice为1时才需要进行计算
    let fieIdList = list.map(item =>
        item.fieIdList.filter(items =>
            !items.hide && [1, 2, 6, 7, 9, 10, 12, 13, 14].includes(items.fieIdType) &&
            (items.fieIdType !== 6 && items.fieIdType !== 7 && items.fieIdType !== 9 && items.fieIdType !== 14 || items.isCalculatePrice === 1) && items.calculateWay != 4
        )
    );
    // 为每个元素添加原始索引
	fieIdList.map((k, kIndex) => {
	    k.map((i, iIndex) => {
	        i.originalIndex = { kIndex, iIndex };
	    });
	});
    let totalList = []
        //处理金额相关的字段
    fieIdList.map(k => {
        let list = []
        k.map(i => {
            //元素周期表、整数、浮点数、范围、字段组情况、预约时长
            if (i.fieIdType == 10 || i.fieIdType == 6 || i.fieIdType == 7 || i.fieIdType == 9 || i.fieIdType == 12 || i.fieIdType == 14) {
                //如果 fieIdType类型为 整数、浮点、范围则计算总金额
                if (i.fieIdType == 6 || i.fieIdType == 7 || i.fieIdType == 14) {
                    if (i.fieIdValue) {
                        i.totalPrice = Number(i.fieIdValue) * Number(i.elementPrice)
                    } else {
                        i.totalPrice = 0
                    }
                }
                //范围需要先计算他的差值
                if (i.fieIdType == 9) {
                    if (i.fieldValueRange && i.fieldValueRange) {
                        let value = Number(i.fieldValueRange) - Number(i.fieIdValue)
                        if (value <= 0) {
                            i.totalPrice = 0
                        } else {
                            i.totalPrice = value * Number(i.elementPrice)
                        }
                    } else {
                        i.totalPrice = 0
                    }

                }
                list.push(i);
            }
            // 单选、多选情况/根据optionId选择的选项id找到对应选项
            if (i.optionId && Array.isArray(i.options)) {
                i.options.forEach(option => {
                    i.optionId.forEach(openid => {
                        if(option.optionId === openid){
                            if(option.unitPrice != 0 || option.isNegotiatedPrice == 1){
                                list.push({
                                    ...option,
                                    fieIdName: i.fieIdName,
                                    specimenNum: i.specimenNum,
                                    calculateWay: i.calculateWay,
                                    fieIdType: i.fieIdType,
                                    //议价字段在选项里面
                                    bargainReminder: option.bargainReminder,
                                    isNegotiatedPrice: option.isNegotiatedPrice
                                });
                            }
                            
                        }
                    })
                });
            }

        })
        totalList.push(list)
    });
    // 按照原始顺序重新排序 totalList
	totalList = totalList.map(list =>
		list.sort((a, b) => {
			if (a.originalIndex && b.originalIndex) {
				if (a.originalIndex.kIndex === b.originalIndex.kIndex) {
					return a.originalIndex.iIndex - b.originalIndex.iIndex;
				} else {
					return a.originalIndex.kIndex - b.originalIndex.kIndex;
				}
			}
		})
	);
    let bargainReminderList = []
    totalList.map(key => {
            key.maps = {}
            key.dest = []
            key.map(item => {
                    //单选、多选金额
                    if (item.fieIdType == 1 || item.fieIdType == 2) {
                        // 根据价格计算方式处理字段(calculateWay)价格
                        // 1 按样品数量 3 固定价格 4 不计算价格
                        if (item.calculateWay == 1) {
                            item.totalPrice = Number(item.unitPrice) * Number(item.specimenNum);
                        } else {
                            item.totalPrice = item.unitPrice
                        }
                        //议价
                        if (item.isNegotiatedPrice == 1) {
                            bargainReminderList.push(item.bargainReminder)
                        }
                    }
                    // 字段组 字段组都直接拿他的totalPrice 字段组可能存在议价的情况
                    if (item.fieIdType == 12) {
                        // 根据价格计算方式处理字段(calculateWay)价格
                        // 1 按样品数量 3 固定价格 4 不计算价格
                        if (item.calculateWay == 1) {
                            if (item.totalPrice) {
                                item.totalPrice = item.totalPrice * item.specimenNum
                            } else {
                                item.totalPrice = 0
                            }
                            if (item.isNegotiatedPrice == 1) {
                                bargainReminderList.push(item.bargainReminder)
                            }
                        } else {
                            if (item.totalPrice) {
                                item.totalPrice = item.totalPrice
                            } else {
                                item.totalPrice = 0
                            }
                            if (item.isNegotiatedPrice == 1) {
                                bargainReminderList.push(item.bargainReminder)
                            }
                        }
                    }
                    //整数、浮点、范围、字段组都直接拿他的totalPrice 字段组可能存在议价的情况
                    if (item.fieIdType == 6 || item.fieIdType == 7 || item.fieIdType == 9 || item.fieIdType == 14) {
                        if (item.totalPrice) {
                            item.totalPrice = item.totalPrice
                        } else {
                            item.totalPrice = 0
                        }
                        // if(item.fieIdType == 12){
                        // 	if(item.isNegotiatedPrice == 1){
                        // 		bargainReminderList.push(item.bargainReminder)
                        // 	}
                        // }
                    }
                    //元素周期表
                    //整数、浮点、范围、字段组都直接拿他的fieIdValue
                    if (item.fieIdType == 10) {
                        if (item.fieIdValue) {
                            let elementList = item.fieIdValue.split(',')
                            if (isGlobal) {
                                item.totalPrice = Number(item.elementPrice) * Number(elementList.length)
                            } else {
                                item.totalPrice = Number(item.elementPrice) * Number(elementList.length) * Number(item.specimenNum)
                            }
                            let startPrice = Number(item.elementPrice) * Number(elementList.length)
                            if (startPrice >= item.startPrice) {
                                item.unitPrice = item.totalPrice
                            } else {
                                item.unitPrice = item.startPrice * Number(item.specimenNum)
                                item.totalPrice = item.unitPrice
                            }
                            // item.unitPrice = item.totalPrice
                        }
                    }
                    //字段多选时合并金额
                    if (!key.maps[item.fieIdId]) {
                        key.dest.push(item);
                        key.maps[item.fieIdId] = item;
                    } else {
                        key.dest.map(j =>  {
                            if (item.fieIdId == j.fieIdId) {
                                j.unitPrice = Number(j.unitPrice) + Number(item.unitPrice);
                                j.totalPrice = Number(j.totalPrice) + Number(item.totalPrice);
                            }
                        });
                    }
                })
                //计算单个样品的总金额
            key.totalMomey = getTotalMoneys(key.dest, 'totalPrice')

            return {
                ...key,
                subChargeVOList: key.dest
            };
        })
        //计算所有样品的总金额
    let totalCost = getTotalMoneys(totalList, 'totalMomey')
    totalCost = mathjs.round(totalCost, 2)
        // totalCost = mathjs.round(mathjs.bignumber(totalCost), 2)
    let result = {
        totalCost,
        totalList,
        bargainReminderList: bargainReminderList,
    }
    return result
}

export default {
    FieldScreen,
    getTotalMoney,
    globalGroupFieIdValue,
    CalculateDuration,
    requiredVerification,
    FieldProcessing,
    inputFieIdValue,
    rangeFieIdValue,
    timeValue,
    getTotalMoneyList,
    convertBuffList
}